import { Box, Flex, Spacer, Text, Tooltip } from '@chakra-ui/react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Badge,
  BadgeVariants,
  ButtonText
} from '@morressier/alembic';

interface HighlightItemProps {
  variant: BadgeVariants;
  icon: IconDefinition;
  heading: string;
  context?: string;
  buttonOnClick?: () => void;
  buttonText?: string;
  borderTopRadius?: boolean;
  borderBottomRadius?: boolean;
  /**
   * When you need more control over the button behavior pass this
   * instead of the buttonOnClick and buttonText props.
   */
  customButton?: React.ReactNode;
}

const renderBadge = (variant: BadgeVariants, icon: IconDefinition) => (
  <Badge variant={variant} marginRight={2} style={{ padding: '2px' }}>
    <Box
      width="24px"
      height="24px"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <FontAwesomeIcon icon={icon} />
    </Box>
  </Badge>
);

const HighlightItem = ({
  variant,
  icon,
  heading,
  context,
  buttonOnClick,
  customButton,
  buttonText
}: HighlightItemProps) => (
  <Flex alignItems="start" gap={2} paddingY={2}>
    <Tooltip
      label={context}
      aria-label="Info icon tooltip"
      placement="top"
      hasArrow
      shouldWrapChildren
    >
      {renderBadge(variant, icon)}
    </Tooltip>
    <Flex flexDirection="column">
      <Text textStyle="headingItem">{heading}</Text>
    </Flex>
    <Spacer />
    {buttonOnClick && buttonText && (
      <ButtonText onClick={buttonOnClick} style={{ flexShrink: 0 }}>
        {buttonText}
      </ButtonText>
    )}
    {customButton ? customButton : null}
  </Flex>
);

export default HighlightItem;
